import React from 'react';

export interface FooterLink {
  label: string;
  href: string;
}

export interface FooterLinksProps {
  links: FooterLink[];
  copyright?: string;
  className?: string;
}

export const FooterLinks: React.FC<FooterLinksProps> = ({
  links,
  copyright = `© ${new Date().getFullYear()}. All rights reserved.`,
  className = '',
}) => {
  return (
    <footer className={`px-6 py-4 border-t border-base-300 ${className}`}>
      <nav className="flex flex-wrap items-center justify-center gap-1 text-xs">
        {links.map((link, index) => (
          <React.Fragment key={link.label}>
            <a
              href={link.href}
              className="link link-hover opacity-60 hover:opacity-100 transition-opacity px-1"
            >
              {link.label}
            </a>
            {index < links.length - 1 && <span className="opacity-40">·</span>}
          </React.Fragment>
        ))}
      </nav>
      {copyright && <p className="text-xs opacity-40 mt-3 text-center">{copyright}</p>}
    </footer>
  );
};
